import { postService } from "./postService"
import {onSiteError} from '@stores'

export const exportAndDownloadService = async (link, method, data, fileName = '') =>{
  try {
    const response  = await postService(link, method, data)
    let blob = await response.blob()
    var url = window.URL.createObjectURL(blob)
    var a = document.createElement('a')
    document.body.appendChild(a)
    a.download = fileName
    a.href = url
    a.click()
    document.body.removeChild(a)
  } catch(err) {
     onSiteError(err.message)
  }
}


// WEBPACK FOOTER //
// ./src/services/exportAndDownloadService.ts